
























import Vue from 'vue'
import {mapState} from 'vuex'
import '@aws-amplify/ui-vue'
import Map from './Map.vue'


import * as actions from '../store/actions'
import * as types from '../store/types'

export default Vue.extend({
  name: 'CrossCutRoot',
  components: {
    Map
  },
  data: ()   => ({
    formFields: [
      {type: "email", label: "Email Address", required: true},
      {type: "password", label: "Password", required: true},
      {type: "phone_number", label: "Phone Number", placeholder: "555 555-5555", required: true},
      {type: "name", label: "Name", placeholder: "Jane Doe", required: true}
    ],
    authConfig: {
      signUpConfig: {
        usernameAlias: 'email',
        signUpFields: [
          {key: 'email', label: 'Email', required: true, type: 'string', placeholder: "Enter your email address"},
          {key: 'password', label: 'Password', required: true, type: 'password', displayOrder: 2, custom: false},
        ]
      }
    }
  }),
  computed: mapState({
    user: (state: any) => state.user as types.Schema$User,
    loggedIn: (state: any, getters: any) =>  getters.loggedIn
  })
  
    
})
